<div style="display: flex;">
  <div style="width: 100%;">
    <mat-accordion *ngIf="flightLleegoService.travelerForm != null" class="formsContainer" multi [@.disabled]="disableAccordionAnimations">
      <mat-expansion-panel *ngFor="
        let travelerControl of flightLleegoService.travelerForm.controls;
        index as i
      " [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "flight.detail-flight.passenger" | translate }} {{ i + 1
            }}{{
            travelerControl.value.name != "" ||
            travelerControl.value.surname != ""
            ? " - "
            : ""
            }}{{ travelerControl.value.name }}
            {{ travelerControl.value.surname }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="formContainer" [formGroup]="travelerControl">
          <div class="row">
            <div class="col-4" *ngIf="shouldShowPassengerField('name')">
              <mat-form-field appearance="none">
                <label>{{ "common.name" | translate }} <span *ngIf="isPassengerFieldMandatory('name')">*</span></label>
                <input type="text" formControlName="name" matInput [required]="isPassengerFieldMandatory('name')" class="form-control form-control--no-border"
                  [ngClass]="{ error: travelerControl.controls['name'].invalid }" />
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="shouldShowPassengerField('surname')">
              <mat-form-field appearance="none">
                <label>{{ "train.user-form.surname" | translate }} <span *ngIf="isPassengerFieldMandatory('surname')">*</span></label>
                <input type="text" formControlName="surname" matInput [required]="isPassengerFieldMandatory('surname')"
                  class="form-control form-control--no-border"
                  [ngClass]="{ error: travelerControl.controls['surname'].invalid }" />
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="shouldShowPassengerField('lastSurname', false)">
              <mat-form-field appearance="none">
                <label>{{ "train.user-form.surname2" | translate }} </label>
                <input type="text" formControlName="lastSurname" matInput
                  class="form-control form-control--no-border" />
              </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="shouldShowPassengerField('gender')">
            <div class="col-12">
              <div class="genderContainer">
                <label>{{ "user.details.gender" | translate }} <span *ngIf="isPassengerFieldMandatory('gender')">*</span></label>
                <mat-radio-group formControlName="gender" [ngClass]="{
                error: travelerControl.controls['gender'].invalid
              }">
                  <mat-radio-button value="Male">
                    {{ "common.male" | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="Female">
                    {{ "common.female" | translate }}
                  </mat-radio-button>
                  <!-- <mat-radio-button value="O"> Otro </mat-radio-button> -->
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-8" *ngIf="shouldShowPassengerField('email')">
              <mat-form-field appearance="none" id="email">
                <div>
                  <label>{{ "common.email" | translate }} <span *ngIf="isPassengerFieldMandatory('email')">*</span></label>
                </div>
                <input type="email" formControlName="email" matInput [required]="isPassengerFieldMandatory('email')"
                  class="form-control form-control--no-border"
                  [ngClass]="{ error: travelerControl.controls['email'].invalid }" />
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="shouldShowPassengerField('phoneNumber')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.phone" | translate }} <span *ngIf="isPassengerFieldMandatory('phoneNumber')">*</span></label>
                <input type="string" formControlName="phoneNumber" matInput [required]="isPassengerFieldMandatory('phoneNumber')"
                  class="form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['phoneNumber'].invalid
                }" />
              </mat-form-field>
            </div>
          </div>
          <div class="row" id="birthDate">
            <div class="col-4" *ngIf="shouldShowPassengerField('birthDate')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.birthdate" | translate }} <span *ngIf="isPassengerFieldMandatory('birthDate')">*</span></label>
                <input type="text" matInput style="display: none" />
                <input id="birthDate" readonly [minDate]="minDateNgStruct" [maxDate]="maxDateNgStruct" name="birthDate"
                  ngbDatepicker #dateInput="ngbDatepicker" (click)="dateInput.toggle()" formControlName="birthDate" [required]="isPassengerFieldMandatory('birthDate')"
                  class="form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['birthDate'].invalid
                }" />
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="shouldShowPassengerField('nationality')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.nationality" | translate }} <span *ngIf="isPassengerFieldMandatory('nationality')">*</span></label>
                <mat-select formControlName="nationality" [required]="isPassengerFieldMandatory('nationality')"
                  class="icon-arrow-rtl form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['nationality'].invalid
                }">
                  <mat-option *ngFor="let country of countries" [value]="country">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="shouldShowPassengerField('expeCountry')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.issuanceCountry" | translate }} <span *ngIf="isPassengerFieldMandatory('expeCountry')">*</span></label>
                <mat-select formControlName="expeCountry" [required]="isPassengerFieldMandatory('expeCountry')"
                  class="icon-arrow-rtl form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['expeCountry'].invalid
                }">
                  <mat-option *ngFor="let country of countries" [value]="country">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-3" *ngIf="shouldShowPassengerField('documentType')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.documentType" | translate }} <span *ngIf="isPassengerFieldMandatory('documentType')">*</span></label>
                <mat-select formControlName="documentType" [required]="isPassengerFieldMandatory('documentType')"
                  class="icon-arrow-rtl form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['documentType'].invalid
                }">
                  <mat-option value="IDENTITY_CARD">
                    {{ "user.details.dni" | translate }}
                  </mat-option>
                  <mat-option value="NIE">
                    {{ "user.form.nie" | translate }}
                  </mat-option>
                  <mat-option value="PASSPORT">
                    {{ "user.details.passport" | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="shouldShowPassengerField('documentNumber')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.number" | translate }} <span *ngIf="isPassengerFieldMandatory('documentNumber')">*</span></label>
                <input type="text" formControlName="documentNumber" matInput [required]="isPassengerFieldMandatory('documentNumber')"
                  class="form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['documentNumber'].invalid
                }" />
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="shouldShowPassengerField('issuanceDate')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.issuanceDate" | translate }} <span *ngIf="isPassengerFieldMandatory('issuanceDate')">*</span></label>
                <input type="text" matInput style="display: none" />
                <input id="issuanceDate" readonly [minDate]="minDateNgStruct" [maxDate]="maxDateNgStruct"
                  name="issuanceDate" ngbDatepicker #dateInput2="ngbDatepicker" (click)="dateInput2.toggle()"
                  formControlName="issuanceDate" [required]="isPassengerFieldMandatory('issuanceDate')" class="form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['issuanceDate'].invalid
                }" />
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="shouldShowPassengerField('expiryDate')">
              <mat-form-field appearance="none">
                <label>{{ "user.form.expiryDate" | translate }} <span *ngIf="isPassengerFieldMandatory('expiryDate')">*</span></label>
                <input type="text" matInput style="display: none" />
                <input id="expiryDate" readonly [minDate]="maxDateNgStruct" name="expiryDate" ngbDatepicker
                  #dateInput3="ngbDatepicker" (click)="dateInput3.toggle()" formControlName="expiryDate" [required]="isPassengerFieldMandatory('expiryDate')"
                  class="form-control form-control--no-border" [ngClass]="{
                  error: travelerControl.controls['expiryDate'].invalid
                }" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-4" *ngIf="shouldShowPassengerField('documents', true)">
              <label style="margin-bottom: 0px !important;">{{ "flight.detail-flight.ff-number" | translate }}</label>
              <span (click)="openFfCardModal(i)" class="icon-edit ml-1" style="cursor: pointer; padding-left: 0.5rem;">
                <i class="ft-edit"></i>
              </span>

              <mat-form-field appearance="none" *ngIf="getFfCardsArray(i) && getFfCardsArray(i).controls.length > 0"
                formGroupName="documents">
                <mat-select [formControl]="getSelectedFfCardControl(i)"
                  class="icon-arrow-rtl form-control form-control--no-border">
                  <mat-option [value]="-1">{{ "my-bookeds.train-flight.no-add-card" | translate }}</mat-option>
                  <mat-option *ngFor="let card of getFfCardsArray(i).controls; let j = index" [value]="j">
                    {{ card.get('cardName').value }} - {{ card.get('cardNumber').value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="none" *ngIf="getFfCardsArray(i) && getFfCardsArray(i).controls.length === 0"
                formGroupName="documents">
                <mat-select placeholder="{{ 'my-bookeds.train-flight.no-cards-available' | translate }}" disabled>
                  <mat-option disabled>
                    {{ "my-bookeds.train-flight.no-cards-available" | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4" *ngIf="canUseResident && shouldShowResidentCityField()">
              <mat-form-field appearance="none">
                <label>
                  {{ "common.city" | translate }}
                  <span *ngIf="isPassengerFieldMandatory('city')">*</span>
                </label>

                <mat-select
                  formControlName="city"
                  [required]="isPassengerFieldMandatory('city')"
                  class="icon-arrow-rtl form-control form-control--no-border"
                  [ngClass]="{
                    error: travelerControl.controls['city'].invalid
                  }"
                >
                  <mat-option
                    *ngFor="let municipality of munipalitiesList"
                    [value]="municipality.municipality"
                  >
                    {{ municipality.municipality }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- <button style="float: left" mat-button matStepperPrevious>
    {{ "flight.detail-flight.previous" | translate }}
    </button> -->
    <div class="p-4 mb-3" *ngIf="flightLleegoService.travelerForm != null">
      <button
        (click)="goNextStep()"
        class="custom-btn"
        [disabled]="flightLleegoService.travelerForm == null || flightLleegoService.travelerForm.invalid"
        [ngClass]="{ disabled: flightLleegoService.travelerForm == null || flightLleegoService.travelerForm.invalid }"
        [matTooltip]="
          flightLleegoService.travelerForm?.invalid
            ? getInvalidString()
            : null
        "
      >
        {{ "flight.result-flight.continue" | translate }}
      </button>
    </div>
  </div>
  <div id="price-col">
    <mat-accordion *ngIf="accomInfo">
      <mat-expansion-panel [expanded]="!accomInfo" class="summary-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "flight.flight-info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="details-container">
          <span *ngIf="canUseResident" class="resident-applied">{{ 'flight.resident-applied' | translate }}</span>
          <div class="details-buy-text" [ngClass]="{ 'no-fare': fareSelected == null }">
            <ng-container *ngIf="fareSelected">
              <ng-container *ngIf="company?.showCommissions || isEmployee; else sinComisiones">
                <div class="buy-text">
                  <div>
                    <div *ngIf="!isPriceWithinRangeMethod(totalPrice) || userFilters.onlyFlightAuthorization"
                      style="display: flex; justify-content: center;">
                      <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
                    </div>
                  </div>
                  <div *ngIf="fareSelected">
                    <div class="total-price base-price">
                      <p>{{ "hotel.base-rate" | translate }}:</p>
                      <p>{{ fareSelected.amount | price }} €</p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #sinComisiones>
                <div class="buy-text">
                  <div class="total-price base-price">
                    <p>{{ "hotel.base-rate" | translate }}:</p>
                    <p>{{ (fareSelected.total) | price }} €</p>
                  </div>

                  <div class="total-price total-price-label">
                    <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                    <p>{{ fareSelected.total | price }} €</p>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion *ngIf="accomInfo" style="margin-top: 1rem;">
      <mat-expansion-panel [expanded]="false" class="summary-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "hotel.accom-info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div *ngIf="accomInfo.needsAuth" style="display: flex; justify-content: center;">
            <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
          </div>
          <div class="room" *ngFor="let room of accomInfo.selectedRooms; let j = index">
            <p style="font-weight: 600;">{{ "hotel.room" | translate}} {{j + 1}}: {{room.name}}</p>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
              <p>{{ "hotel.base-rate" | translate }}: </p>
              <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
              <p *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0" style="color: #f46f69"
                matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{room.rates[0].price.fees.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) === 'E'">
              <p *ngIf="room.rates[0].price.baseRate && room.rates[0].price.baseRate.amount > 0">{{
                "hotel.base-rate" | translate }}: </p>
              <p>{{ room.rates[0].price.baseRate.amount | price }}€</p>
            </div>
            <div class="total-price base-price"
              *ngIf="room.rates[0].price.taxAndServiceFee && room.rates[0].price.taxAndServiceFee.amount > 0">
              <p matTooltip="{{ 'hotel.taxes-and-fees-details' |translate }}">{{ "hotel.taxes-and-fees" |
                translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{ room.rates[0].price.taxAndServiceFee.amount | price }}€</p>
            </div>
            <div class="total-price base-price"
              *ngIf="room.rates[0].price.salesTax && room.rates[0].price.salesTax.amount > 0">
              <p>{{
                "hotel.sales-tax" | translate }}: </p>
              <p>{{ room.rates[0].price.salesTax.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0">
              <p style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{ room.rates[0].price.fees.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && room.rates[0].price.totalPrice.total">
              <p>{{ "search.search-booked.total-price-by-room" | translate }}: </p>
              <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
            </div>
          </div>
          <div class="total-price total-price-label">
            <p>{{ "search.search-booked.total-price" | translate }}: </p>
            <p>{{ getTotalPriceAccom() | price }}€</p>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="total-price total-price-label" *ngIf="accomInfo">
      <p>{{ "hotel.total-price-package" | translate }}: </p>
      <p>{{ getTotalPackage() | price }} €</p>
    </div>
  </div>
</div>
